import Sqids from 'sqids'

const sqids = new Sqids({ minLength: 8 })

export const encodeId = (id) => {
  return sqids.encode([id])
}

export const encodeIds = (ids = []) => {
  const rawIds = Array.isArray(ids) ? ids : [ids]

  // รองรับกรณีที่ id ถูก encode มาแล้ว (เช่น sqids string)
  if (
    rawIds.length === 1 &&
    typeof rawIds[0] === 'string' &&
    rawIds[0] !== '' &&
    Number.isNaN(Number(rawIds[0]))
  ) {
    return rawIds[0]
  }

  const normalizedIds = rawIds
    .map((id) => Number(id))
    .filter((id) => Number.isInteger(id) && id >= 0)

  if (normalizedIds.length === 0) {
    return ''
  }

  return sqids.encode(normalizedIds)
}

export const decodeId = (hash) => {
  return sqids.decode(hash)[0]
}
